import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/x-circle.svg'
import _imports_2 from '@/assets/icons/current_location.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f21aa74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "img-search",
  src: _imports_0,
  "aria-hidden": "true",
  alt: ""
}
const _hoisted_2 = ["name", "type", "placeholder", "readonly", "value"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-current-location",
  src: _imports_2,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-wrapper", { emphasis: $props.emphasis, fixed: $props.fixed }]),
    role: "button",
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onClickSearchInput')))
  }, [
    (!$props.isSearchIconRight)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("input", {
      ref: "searchInputRef",
      class: _normalizeClass(["search-box wizdome-custom", { left: $props.isSearchIconRight }]),
      name: $props.name,
      type: $props.type,
      placeholder: $props.placeholder,
      readonly: $props.readonly,
      value: $props.value,
      inputmode: "search",
      enterkeyhint: "search",
      autocomplete: "off",
      onInput: $setup.onInput,
      onChange: $setup.onChange,
      onFocus: $setup.onFocused,
      onBlur: $setup.onBlurred,
      onKeyup: _withKeys($setup.emitOnEnter, ["enter"])
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2),
    (!$props.hideClearBtn && $setup.isFocused)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          "aria-label": "검색어 지우기",
          onClick: _withModifiers($setup.clearText, ["stop"]),
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(["img-clear-text", { only: !$props.locationSearch && !$props.showSearchButton }]),
            src: _imports_1,
            "aria-hidden": "true",
            alt: ""
          }, null, 2 /* CLASS */)
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    ($props.showSearchButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "search-button",
          disabled: $props.searchButtonDisabled,
          onClick: _withModifiers($setup.emitOnClickSearchButton, ["stop"]),
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          "aria-label": "검색"
        }, _toDisplayString($props.searchButtonText), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_3))
      : _createCommentVNode("v-if", true),
    ($props.isSearchIconRight)
      ? (_openBlock(), _createBlock($setup["InlineSvg"], {
          key: 3,
          class: "img-search right",
          src: require('@/assets/icons/search.svg'),
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["src"]))
      : _createCommentVNode("v-if", true),
    ($props.locationSearch)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 4,
          to: { name: $setup.RouterName.MapOfNearbyBusStops },
          "aria-label": "내 위치 근처 정류장 보기",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          onMouse: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}